<template>
  <div class="wrap">
    <div class="head">
      <!-- <img class="logo" :src="require('../assets/logo.png')" alt="" /> -->
      <div class="title">
        铸学教育后台管理
      </div>
    </div>
    <div class="form">
      <a-form-model v-if="!updatePasswordPage" ref="loginForm" :model="loginForm" :rules="rules">
        <a-form-model-item label="" required prop="loginCode">
          <a-input size="large" placeholder="用户名" v-model="loginForm.loginCode" :maxLength="16" autoFocus>
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item label="" required prop="password">
          <a-input size="large" type="password" required placeholder="密码" v-model="loginForm.password"
            @keyup.enter.native="login" :maxLength="16">
            <a-icon slot="prefix" type="key" />
          </a-input>
        </a-form-model-item>
        <a-button size="large" type="primary" block @click="login" :loading="loading">登录</a-button>
      </a-form-model>

      <a-form-model v-else ref="updatePasswordForm" :model="updatePasswordForm" :rules="rules2">
        <a-form-model-item label="" required prop="oldPassword">
          <a-input ref="oldPasswordInput" type="password" required size="large" placeholder="旧密码"
            v-model="updatePasswordForm.oldPassword" :maxLength="16" autoFocus>
            <a-icon slot="prefix" type="key" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item label="" required prop="newPassword">
          <a-input size="large" type="password" required placeholder="新密码" v-model="updatePasswordForm.newPassword"
            @keyup.enter.native="updatePassword" :maxLength="16" :autoFocus="false">
            <a-icon slot="prefix" type="key" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button size="large" type="primary" block @click="updatePassword" :loading="loading">确定修改</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button size="large" block @click="backLogin()">返回登录</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>

    <div class="footer">
      <div class="">
        <a-space size="large">
          <a href="#">帮助</a>
          <a href="#">隐私</a>
          <a href="#">条款</a>
        </a-space>
      </div>
      <!-- <div class="copyright">Copyright © 2021 ctjsoft.com</div> -->
    </div>
  </div>
</template>

<script>
import { auth } from "../request/api"
import { mapState, mapMutations } from "vuex"
import { SET_USER_INFO } from "@/store/mutation-types"
import config from "../../package.json"


export default {
  created() {
    this.config = config
    const isNeedUpdatePassword = this.$route.query.isNeedUpdatePassword
    if (isNeedUpdatePassword && this.token != "") {
      this.updatePasswordPage = true
    }
  },
  data() {
    
    return {
      loginForm: {
        loginCode: "",
        password: ""
      },
      updatePasswordForm: {
        oldPassword: "",
        newPassword: "",
        staffId:""
      },
      rules: {
        loginCode: [
          { required: true, message: "请填写用户名", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入用户名密码", trigger: "change" },
        ]
      },
      rules2: {
        oldPassword: [
          { required: true, message: "请填写旧密码", trigger: "change" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "change" }
        ]
      },
      loading: false,
      updatePasswordPage: false
    }
  },
  
  methods: {
    ...mapMutations({
      setUserInfo: SET_USER_INFO
    }),

    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          auth.login(this.loginForm)
            .then((data) => {
              if (data.code == 500) {
                this.$message.warn(data.msg)
                this.loading = false
              } else {
                this.$message.success("登录成功")
                this.setUserInfo(data)
                this.$router.push("/user")
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.$message.warn("请填写用户和密码")
        }
      })
    },
    updatePassword() {
      this.$refs.updatePasswordForm.validate((valid) => {
        if (valid) {
          if (this.userInfo) {
            if (
              this.updatePasswordForm.oldPassword ==
              this.updatePasswordForm.newPassword
            ) {
              this.$message.warn("新密码不能和老密码相同")
              return false
            }

            let reg = /[a-zA-Z]\w{6,9}/
            if(!reg.test(this.updatePasswordForm.newPassword)){
              this.$message.warn("密码以字母开头，长度在6~9之间，只能包含字母、数字和下划线")
              return false
            }
            this.loading = true
            this.updatePasswordForm.staffId = this.userInfo.staffId
            auth.modifyPassword(this.updatePasswordForm)
              .then((data) => {
                console.log("data=",data)
                if (data.code == 200) {
                  this.$message.success("密码修改成功")
                  this.setUserInfo(data)
                  this.$router.push("/")
                } else {
                  this.$message.warn(data.msg);
                  this.loading = false
                }
              })
              .catch(() => {
                this.resetForm()
              })
          } else {
            this.$message.error("未登录，请先登录")
            this.backLogin()
          }
        }
      })
    },
    backLogin() {
      this.updatePasswordPage = false
      this.resetForm()
    },
    resetForm() {
      let loading = false
      let loginForm = {
        loginCode: "",
        password: ""
      }
      let updatePasswordForm = {
        oldPassword: "",
        newPassword: ""
      }
      Object.assign(this, {
        loading,
        loginForm,
        updatePasswordForm
      })
    },
    
  },
  computed: {
    ...mapState(["token", "userInfo"])
  },

}
</script>

<style lang="stylus" scoped>
.wrap
    width: 100%;
    min-height: 100%;
    background: #f0f2f5 url(../assets/background.svg) no-repeat 50%;
    background-size: 100%;
    position: relative;
    .head
        height 300px
        display flex
        flex-direction column
        align-items center
        justify-content center
        .logo
            width 300px
        .title
            font-size 32px
            font-weight 800
            padding 10px
    .form
        width 400px
        margin 0 auto
    .footer
        display flex
        height 50px
        flex-direction column
        align-items center
        justify-content center
        position absolute
        bottom 50px
        width 100%
        .copyright
            margin-top 20px
</style>
